export default function initAnimation()
{
    const animations = document.querySelectorAll('.js-animation');
    if (animations.length === 0) {
        return;
    }

    const areas =  {
        root: null,
        rootMargin: "-10% 0px -20%",
        threshold: 0,
    };

    const parentObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.parentNode.classList.add('is-activated');
                parentObserver.unobserve(entry.target);
            }
        });
    }, areas);

    const currentObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-activated');
                currentObserver.unobserve(entry.target);
            }
        });
    }, areas);

    const childrenObserver = new IntersectionObserver(entries => {
        entries.forEach( entry => {
            if (entry.isIntersecting) {
                let children = [ ...entry.target.children ];
                if (entry.target.classList.contains('animation-step-fade-in-rtl')) {
                    children = children.reverse();
                    // console.log('Reversed.', children);
                }
                // console.log('Activating...', entry, entry.target, entry.target.children);

                let stepSec = 150;
                if (entry.target.classList.contains('animation-step-delay-2ms')) {
                    stepSec = 200;
                } else if (entry.target.classList.contains('animation-step-delay-5ms')) {
                    stepSec = 500;
                } else if (entry.target.classList.contains('animation-step-delay-7ms')) {
                    stepSec = 700;
                } else if (entry.target.classList.contains('animation-step-delay-1s')) {
                    stepSec = 1000;
                } else if (entry.target.classList.contains('animation-step-delay-2s')) {
                    stepSec = 2000;
                } else if (entry.target.classList.contains('animation-step-delay-3s')) {
                    stepSec = 3000;
                }

                children.forEach( (node, index) => {
                    setTimeout( () => {
                        node.classList.add('is-activated');
                        // console.log('Activated', node);
                    }, (index * stepSec));
                });

                currentObserver.unobserve(entry.target);
                // console.log('All activated.', entry.target);
            }
        });
    }, areas);

    let isAnimation = false;
    animations.forEach(node => {
        if (!isAnimation) {
            isAnimation = true;
            const animationContainer = document.querySelector('.wp-site-blocks');
            if (animationContainer) {
                animationContainer.classList.add('has-wb-animation');
            }
        }

        if (node.classList.contains('wp-block-cover')) {
            // node.classList.add('has-wb-animation');
            const nodeBody = node.querySelector('.wp-block-cover__inner-container');

            if (nodeBody) {
                parentObserver.observe(nodeBody);
            }
        } else {
            // node.parentNode.classList.add('has-wb-animation');
            const classes = node.className.split(' ');
            const isStep = classes.some(cls => cls.indexOf('animation-step-') > -1);
            // console.log('animation-step-', isClass, node);

            if (isStep) {
                childrenObserver.observe(node);
            } else {
                currentObserver.observe(node);
            }
        }
    });
}
